module.exports = __webpack_public_path__ + "img/logo-white.9282861d.svg";